import React from "react";
import "./index.css";
import { HashLink as Link } from "react-router-hash-link";
import logo from "./assets/RFM.png";

function Navbar() {
  return (
    <nav class="navbar bg-primary flex flex-col items-start justify-center p-5 gap-y-6 md:flex-row md:items-center md:justify-between md:px-10 lg:px-20">
      <Link className="anchorLinkNav" to="/" smooth activeStyle>
        <img className="logo w-20 lg:w-32" src={logo} alt="Logo"></img>
      </Link>

      <div
        id="nvbr"
        class="navbar-links flex flex-row justify-between w-full md:justify-end md:gap-x-14"
      >
        <Link
          className="anchorLinkNav text-small md:text-body"
          to="/About"
          smooth
          activeStyle
        >
          About me →
        </Link>
        <Link
          className="anchorLinkNav text-small md:text-body"
          to="/Works"
          smooth
          activeStyle
        >
          Works →
        </Link>
        <a
          href="https://read.cv/rizqyfachri"
          target="_blank"
          rel="noopener noreferrer"
          className="resumeLink text-small md:text-body"
        >
          Resume →
        </a>
      </div>
    </nav>
  );
}

export default Navbar;
